import labels from "emun.products/_labels";

const productConfig = {
  filters: [
    { tag: "Division", title: labels.division },
    { tag: "Collection" },
    { tag: "Stock Status" },
    { tag: "Web Categories", title: "Product Categories" },
    { tag: "Sub WebCategories 1", title: "Refined Product Categories" },
    //{ tag: 'Sub WebCategories 2', title: 'Sub WebCategories 2' },
    {
      number: "WholesalePrice",
      title: labels.wholesalePrice,
      min: 0,
      max: 2000,
      step: 0.01,
    },
    {
      number: "MinimumOrderQty",
      title: labels.minimumOrderQty,
      min: 0,
      max: 2000,
      step: 1,
    },
    { groupBy: "Status", authorize: (s) => s.isRepOrAbove() },
    { date: "CreatedOn", title: labels.createdOn },
  ],
  orderBy: "VendorId,Id",
  showNavPanel: false,
  hideLeftNav: false,
  maxNavHeight: "",
  navTitle: "",
  useWarehouseAvailability: true,
  showInactive: false,
  hotspotDefaultOutlineOn: false,
  showBulkActions: false,
  useProductEditorPrompt: false,
  statuses: ["Active", "Inactive", "Discontinued"],
  itemTypes: ["Standard", "Kit", "AsShown", "OnDemand"],
  useMandrill: false,
  hideProductMoreInfo: false,
  showAvailabilityInGrid: false,
  printListItemsPerPage: "4",
  printListItemsPerPageArray: [ 1, 2, 4, 6, 9, 12],
    showCatalogPageAsAlternateImage: false,
  listDaysExpire: 60,
  useQuickViewFromProductList: true,
  defaultProductListVisibility: []
};

export default productConfig;